@if (headerVisible) {
  <lib-viz-header
    class="app-header"
    [appName]="appTitle"
    [brandLink]="brandLink"
    [menus]="headerMenus"
    (helpItemSelected)="onHelpItemSelected($any($event))"
    (appsItemSelected)="onAppsItemSelected($any($event))"
    (userItemSelected)="onUserItemSelected($any($event))"
  ></lib-viz-header>
}
